<template>
  <div  :class="classes" :style="styles" @click="back">
    <div :class="innerClasses">
      <Icon type="ios-arrow-down" />
    </div>
  </div>
</template>
<script>
import { scrollTop } from 'view-design/src/utils/assist';
import { on, off } from 'view-design/src/utils/dom';
const prefixCls = 'ivu-back-bottom';

export default {
  props: {
    right: {
      type: Number,
      default: 30
    },
    bottom: {
      type: Number,
      default: 30
    },
    duration: {
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      backTop: false
    };
  },
  computed: {
    classes () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-show`]: this.backTop
        }
      ];
    },
    styles () {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      };
    },
    innerClasses () {
      return `${prefixCls}-inner`;
    }
  },
  mounted () {
    on(window, 'scroll', this.handleScroll);
    on(window, 'resize', this.handleScroll);
  },
  beforeDestroy () {
    off(window, 'scroll', this.handleScroll);
    off(window, 'resize', this.handleScroll);
  },
  methods: {
    handleScroll () {
      const windowHegiht = window.innerHeight + window.pageYOffset
      const bodyscroll = this.$parent.$el.scrollHeight
      this.backTop = windowHegiht < bodyscroll;
    },
    back () {
      const stop = document.documentElement.scrollTop || document.body.scrollTop;
      const sbottom = this.$parent.$el.scrollHeight
      scrollTop(window, stop, sbottom, this.duration);
      this.$emit('on-click');
    }
  }
}
</script>
<style lang="scss">
.ivu-back-bottom {
  z-index: 10;
  position: fixed;
  cursor: pointer;
  display: none;
  &-show {
    display: block;
  }
  &-inner {
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 2px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease-in-out;
  }
  i {
    color: #fff;
    font-size: 24px;
    padding: 8px 12px;
  }
}
</style>